document.addEventListener('DOMContentLoaded', function () {
  // Calculate and set header height CSS variable
  function getHeaderHeight() {
    let header = document.querySelector('header');
    let announcementBar = document.querySelector('[id*="announcement-bar"]');

    let headerHeight = 0;

    if (announcementBar) {
      headerHeight += announcementBar.offsetHeight;
    }

    if (header) {
      headerHeight += header.offsetHeight;
     // document.documentElement.style.setProperty('--header-h', headerHeight + 'px');
    }

    if (window.innerWidth > 1023) {
      document.body.style.setProperty('overflow', 'auto');
    }
  }
  getHeaderHeight();
  window.addEventListener('resize', getHeaderHeight);
});

document.addEventListener('DOMContentLoaded', function () {
  const headerRoot = document.querySelector('[data-header-root]');
  if (!headerRoot) return;

  const menuButton = headerRoot.querySelector('[data-menu-toggle]');
  const mobileMenu = headerRoot.querySelector('.header-menu');
  const overlay = headerRoot.querySelector('[data-menu-overlay]');
  const isIndexPage = !headerRoot.classList.contains('scroll');
  let isScrolled = false;
  let scrollTimeout = null;


  window.onscroll = function(e) {
    if ( this.scrollY > this.oldScroll ) {
      headerRoot.classList.add('scroll');
    } else if (this.scrollY < 1 && this.scrollY <= this.oldScroll) {
      headerRoot.classList.remove('scroll');
    }

    this.oldScroll = this.scrollY;
  }

  const setMenuState = (opened) => {
    headerRoot.classList.toggle('opened', opened);
    if (mobileMenu) mobileMenu.classList.toggle('is-open', opened);
    if (overlay) overlay.style.opacity = opened ? '1' : '0';
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', opened);
    }

    document.body.style.setProperty('overflow', opened ? 'hidden' : '');
  };

 

  if (menuButton) {
    menuButton.addEventListener('click', () => {
      const willOpen = !headerRoot.classList.contains('opened');
      setMenuState(willOpen);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', () => setMenuState(false));
  }
});